var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("PAGE1")]),_c('button',{on:{"click":_vm.toPage2}},[_vm._v("toPage2")])])
}
var staticRenderFns = []

export { render, staticRenderFns }